import baseAPI from "@/api/base";
import {
    GetVerifications,
    ToggleVerificationIsActive,
    UpdateVerificationStatus,
    VerifyTransaction,
} from "@/dtos/verification.dto";
import {
    DELETE_VERIFICATION_URL,
    TOGGLE_VERIFICATION_IS_ACTIVE_URL,
    UPDATE_VERIFICATION_STATUS_URL,
    VERIFICATION_URL,
    VERIFY_TRANSACTION_URL,
} from "@/utils/urls";
import { AxiosResponse } from "axios";

class Verification {
    static getVerifications = async (
        params: GetVerifications,
    ): Promise<AxiosResponse> => {
        // `searchTerm` is a client-side filter only — never forward it to the API.
        const { searchTerm, ...query } = params ?? {};
        return baseAPI.get(VERIFICATION_URL, { params: query });
    };

    // POST /verification/verify — manual verification against the bank receipt.
    static verifyTransaction = async (
        body: VerifyTransaction,
    ): Promise<AxiosResponse> => {
        return baseAPI.post(VERIFY_TRANSACTION_URL, body);
    };

    // PATCH /verification/:id/image — attach the captured receipt image to a
    // verification created via /verify (multipart, field `image`). Mirrors the
    // mobile scanner's background, best-effort upload.
    static attachReceiptImage = async (
        id: string,
        image: Blob,
    ): Promise<AxiosResponse> => {
        const form = new FormData();
        form.append("image", image, "receipt.jpg");
        return baseAPI.patch(`${VERIFICATION_URL}/${id}/image`, form, {
            headers: { "Content-Type": "multipart/form-data" },
        });
    };

    static updateStatus = async (
        body: UpdateVerificationStatus,
    ): Promise<AxiosResponse> => {
        return baseAPI.patch(UPDATE_VERIFICATION_STATUS_URL, body);
    };

    static toggleIsActive = async (
        body: ToggleVerificationIsActive,
    ): Promise<AxiosResponse> => {
        return baseAPI.patch(TOGGLE_VERIFICATION_IS_ACTIVE_URL, body);
    };

    static deleteVerification = async (id: string): Promise<AxiosResponse> => {
        return baseAPI.delete(`${DELETE_VERIFICATION_URL}/${id}`);
    };
}

export default Verification;
